import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, toRefs } from 'vue'
    import { Viewing } from '@/interface'
    import ViewingCardImage from '@/components/ViewingCard/ViewingCardImage.vue'
    import ViewingCardLayout from '@/components/ViewingCard/ViewingCardLayout.vue'
    import ViewingCardHomeDetails from '@/components/ViewingCard/ViewingCardHomeDetails.vue'
    import ViewingCardAppointmentDetails from '@/components/ViewingCard/ViewingCardAppointmentDetails.vue'

    
export default /*#__PURE__*/_defineComponent({
  props: {
    viewing: null
  },
  setup(__props: any) {

const props = __props as { viewing: Viewing }

    
    const { viewing } = toRefs(props)

    const viewingImages = computed(() => {
        if (!viewing.value) {
            return []
        }

        return viewing.value.media
            .filter(v => v.vrijgave)
            .filter(v => typeof v.linkToOriginal === 'string')
            .filter(v => ['HOOFDFOTO', 'FOTO'].includes(v.soort))
            .sort((a, b) => a.volgnummer < b.volgnummer ? -1 : 1)
            .map(v => v.linkToOriginal)
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ViewingCardLayout, null, {
    default: _withCtx(() => [
      _createVNode(ViewingCardImage, {
        images: _unref(viewingImages),
        text: _unref(viewing).response === null ? _ctx.$t('viewing.status.withoutResponse') : _ctx.$t('viewing.status.withResponse')
      }, null, 8, ["images", "text"]),
      _createVNode(ViewingCardHomeDetails, { viewing: _unref(viewing) }, null, 8, ["viewing"]),
      _createVNode(ViewingCardAppointmentDetails, { viewing: _unref(viewing) }, null, 8, ["viewing"])
    ]),
    _: 1
  }))
}
}

})